import { fill, get, map } from 'lodash';
import React, { useContext } from 'react';
import { EDIT_SCHEMA_MODE } from '../../../../../constants';
import { SchemaDisplayContext } from '../../../../context';
import { phaseRootProps, usePhaseStyles } from '../../style';

const LEFT_MARGIN = 5;

function Phases(props) {
  const { nodeWidth, phases, isShow } = props;
  const { schema: { mode } } = useContext(SchemaDisplayContext);
  const relativeRotation = get(phases, 'relativeRotation');
  const absoluteRotation = get(phases, 'absoluteRotation');
  let phaseCount;

  if (relativeRotation) {
    phaseCount = Object.keys(relativeRotation).length;
  }

  const styles = usePhaseStyles({ count: phaseCount });
  const position = mode === EDIT_SCHEMA_MODE
    ? LEFT_MARGIN
    : (nodeWidth / 2) - (phaseRootProps({ count: phaseCount }).width / 2);

  const rotationObj = absoluteRotation && Object.keys(absoluteRotation).length > 0 ? absoluteRotation : relativeRotation;

  return absoluteRotation && isShow ? (
    <foreignObject
      className={styles.root}
      x={position}
      y={-16}
      width={56}
      height={16}
    >
      {
        fill(Array(phaseCount), 1).map(
          (item, index) => (
            <span
              key={`phase-${rotationObj[index + 1]}`}
              className={`${styles.item} phase-${rotationObj[index + 1]}`}
              draggable={false}
            >
              {rotationObj[index + 1]}
            </span>
          ),
        )
      }
      <div className={`tooltip phases-tooltip ${mode === EDIT_SCHEMA_MODE ? 'edit-mode' : ''}`}>
        <span>
          Relative:
          {' '}
          {map(relativeRotation, (phase) => phase)}
          <br />
          Absolute:
          {' '}
          {map(absoluteRotation, (phase) => phase)}
        </span>
      </div>
    </foreignObject>
  ) : null;
}

export default Phases;
